// Benepack OMS · Topbar (WF-02 §2.3 + §2.4)
// 56px 白底 · 左: Breadcrumb · 右: 通知 Badge + 语言切换 + 用户菜单
// GL-12: 修改密码解禁 → ChangePasswordModal (成功后强制重登 · Modal 内闭环)
import { useState } from 'react';
import { Button, Dropdown, Layout, Space, Typography } from 'antd';
import { GlobalOutlined, LogoutOutlined, UserOutlined, LockOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from './Breadcrumb';
import { ChangePasswordModal } from './ChangePasswordModal';
import { ApprovalBell } from './ApprovalBell';
import { useAuth } from '@/hooks/use-auth';

const { Header } = Layout;
const { Text } = Typography;

export function Topbar() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [pwOpen, setPwOpen] = useState(false);

  const userMenu: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: t('topbar.profile'),
      disabled: true,
    },
    {
      key: 'changePassword',
      icon: <LockOutlined />,
      label: t('topbar.changePassword'),
      onClick: () => setPwOpen(true),
    },
    { type: 'divider' as const },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('topbar.logout'),
      onClick: async () => {
        await logout();
        nav('/login', { replace: true });
      },
    },
  ];

  const langMenu: MenuProps['items'] = [
    {
      key: 'zh-CN',
      label: '简体中文',
      onClick: () => void i18n.changeLanguage('zh-CN'),
    },
    {
      key: 'en-US',
      label: 'English（即将支持）',
      disabled: true,
    },
  ];

  return (
    <Header
      style={{
        padding: '0 24px',
        background: '#FFFFFF',
        borderBottom: '1px solid #E5E7EB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Breadcrumb />
      <Space size={20}>
        {/* 审批提醒铃铛: 待审单据徽标 + 下拉清单 (go-live 反馈 #3 · 共享 usePendingApprovals 单轮询) */}
        <ApprovalBell />
        {/* P2-5 (UI-2): 触发器用真 Button (可 Tab 聚焦/回车展开) · 替代裸 icon/Space cursor:pointer */}
        <Dropdown menu={{ items: langMenu }} placement="bottomRight">
          <Button
            type="text"
            aria-label={t('topbar.language')}
            icon={<GlobalOutlined style={{ fontSize: 18 }} />}
          />
        </Dropdown>
        <Dropdown menu={{ items: userMenu }} placement="bottomRight">
          <Button type="text" style={{ height: 'auto', padding: '4px 8px' }}>
            <Space>
              <UserOutlined />
              <Text>{user?.display_name ?? user?.username ?? '—'}</Text>
            </Space>
          </Button>
        </Dropdown>
      </Space>
      <ChangePasswordModal open={pwOpen} onClose={() => setPwOpen(false)} />
    </Header>
  );
}
